import firebase from 'firebase/app';
import 'firebase/messaging';

var firebaseConfig = {
    apiKey: "AIzaSyAyEyqFmstXWEdogOWGU1KXPcQc1F33GVg",
    authDomain: "cowin-d9567.firebaseapp.com",
    projectId: "cowin-d9567",
    storageBucket: "cowin-d9567.appspot.com",
    messagingSenderId: "211884644077",
    appId: "1:211884644077:web:efe25a478448a1d81b5ee4",
    measurementId: "G-Z15V1RP5EM"
};

// firebase.initializeApp(firebaseConfig);
const messaging = firebase.messaging();


export const getToken = (setTokenFound) => {
    return messaging.getToken({ vapidKey: 'BD37lnV-o4oRp8mRrabPF17lPWCwvKlEAPwGVRK7RZxqlZX3L-R5FSZnCTpTC66t0sgiDIxd9iWiFHPaVq8U-p4' }).then((currentToken) => {
        if (currentToken) {
            console.log('current token for client: ', currentToken);
            setTokenFound(true);
            // Track the token -> client mapping, by sending to backend server
            // show on the UI that permission is secured
        } else {
            console.log('No registration token available. Request permission to generate one.');
            setTokenFound(false);
            // shows on the UI that permission is required 
        }
    }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
        // catch error while creating client token
    });
}




// export const onMessageListener = () =>
//     new Promise((resolve) => {
//         messaging.onMessage((payload) => {
//             resolve(payload);
//         });
//     });